import { where } from 'firebase/firestore';
import {
  fetchByTable,
  addDataToTableWithCustomId,
  updateDataById,
} from '../utils';

export const addUser = async (user, setLoading) =>
  addDataToTableWithCustomId({
    tableName: 'users',
    id: user.uid,
    data: user,
    setLoading,
  });

export const getUserByUid = async uid =>
  fetchByTable({
    tableName: 'users',
    whereCondition: where('uid', '==', uid),
  }).then(res => (res.length > 0 ? res[0] : null));
